import { render, staticRenderFns } from "./vc-loading.vue?vue&type=template&id=358052e1&scoped=true&"
import script from "./vc-loading.vue?vue&type=script&lang=js&"
export * from "./vc-loading.vue?vue&type=script&lang=js&"
import style0 from "./vc-loading.vue?vue&type=style&index=0&id=358052e1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358052e1",
  null
  
)

export default component.exports